import React from "react";
import SglContext from '../SglContext';
import { useNavigate } from 'react-router-dom';
import ReactModal from "react-modal";
import axios from "axios";
import { useSearchParams } from 'react-router-dom';

import $ from 'jquery';
import JWPlayer from '@jwplayer/jwplayer-react';

import VideoSubscription from "../videos/VideoSubscription";
import "./subscription.css";
import "./videos.css";


import report_icon from "../images/report.png";
import download_video from "../images/download-vid.png";
import add_playlist_icon from "../images/add-playlist.png";
import delete_image from "../images/trash.png";
import indicator_icon from "../images/Indicator.gif";
import play_video from "../images/play-video.png";
import horse_logo from "../images/horse-logo.png";
import play from '../images/play19.png';

window.jQuery = $
// const { event } = require("jquery");
// const sgl_webservice_videos_list = Sgl.nestApiUrl + "/videos";
// const sgl_webservice_videos = Sgl.sglApiUrl + '/iphonev2/videosv2/';
// const user_info_url = Sgl.nestApiUrl + "/users/getUser";
let is_mobile = false;

var AddModal = ReactModal;
// var Link = ReactRouterDOM.Link;

class VideoDetail extends React.Component {

  get sgl_webservice_videos_list() {
    return this.context.nestApiUrl + '/videos';
  }

  get sgl_webservice_videos() {
    return this.context.sglApiUrl + '/iphonev2/videosv2/';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getUser';
  }

  state = {
    filters: {},
    is_user_authorized: false,
    total_rows: 0,
    videos_list: [],
    playlists: [],
    is_mobile: false,
    timeout: null,

    loading: true,
    userData: {},
    login_people_id: -1,

    gridView: true,
    play_video_path: '',
    video_to_play: {},
    video_data: {},
    is_show_entry_videos: true,
    playing_preview: false,

    is_open_get_video_url: false,
    is_open_report_problem_modal: false,
    is_open_add_to_playlist_modal: false,

    report_problem_error_msg: '',
    video_reported: false,

    video_playlists: [],
    create_playlist_error_msg: '',
    create_playlist_success_msg: '',
    fetching_playlist: true,

    is_open_download_subscription_modal: false,
    is_open_do_subscription_modal: false,
    is_download_subscription: false,
    download_purchased: false,
    video_to_subscribe: {}
  };

  constructor(props) {
    super(props);
    this.PaginationElement = React.createRef();

    // bind function in constructor instead of render

    this.openGetVideoUrlModal = this.openGetVideoUrlModal.bind(this);
    this.closeGetVideoUrlModal = this.closeGetVideoUrlModal.bind(this);
    this.afterOpenUrlModal = this.afterOpenUrlModal.bind(this);

    this.openReportProblemModal = this.openReportProblemModal.bind(this);
    this.closeReportProblemModal = this.closeReportProblemModal.bind(this);

    this.openAddToPlaylistModal = this.openAddToPlaylistModal.bind(this);
    this.closeAddToPlaylistModal = this.closeAddToPlaylistModal.bind(this);

    // this.getVideoUrl = this.getVideoUrl.bind(this);
    this.fetchFile = this.fetchFile.bind(this);

    this.openDownloadSubscriptionModal = this.openDownloadSubscriptionModal.bind(this);
    this.closeDoSubscriptionModal = this.closeDoSubscriptionModal.bind(this);
    this.downloadVideoAfterSubscribe = this.downloadVideoAfterSubscribe.bind(this);
  }

  getBrowserInfo() {
    var sBrowser;
    var sUsrAg = window.navigator.userAgent;

    // The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = "unknown";
    }
    return sBrowser;
  }
  ////// download functions ///////////
  fetchFile() {
    // var vid = this.props.video_to_play.videos_sgl_id;
    if (this.state.video_to_play.video_downloadable || this.state.download_purchased) {
      window.open(
        this.sgl_webservice_videos + 'Download/vid/' + this.props.searchParams.get('vid') + '/customer_id/' + this.context.company_id,
        '_blank' // <- This is what makes it open in a new window.
      );
      // window.location.href = sgl_webservice_videos + 'Download/vid/'+sgl_video_id+'/customer_id/'+this.context.company_id;

      // return sgl_webservice_videos + 'Download?vid='+vid+'&customer_id='+this.context.company_id;
    } else {
      this.openDownloadSubscriptionModal();
    }
  }

  openDownloadSubscriptionModal() {
    this.setState({
      is_open_do_subscription_modal: true,
      is_download_subscription: true,
      video_to_subscribe: this.state.video_to_play
    });
    // window.jwplayer("myDetailElement").play(false);
  }

  closeDoSubscriptionModal() {
    this.setState({
      is_open_do_subscription_modal: false,
      is_download_subscription: false,
      video_to_subscribe: {}
    });
  }
  downloadVideoAfterSubscribe() {
    // this.getVideoData();
    this.setState({ download_purchased: true });
    this.closeDoSubscriptionModal();
    // var vid = this.props.video_to_play.videos_sgl_id;

    if (this.state.is_download_subscription) {
      window.open(
        this.sgl_webservice_videos + 'Download/vid/' + this.props.searchParams.get('vid') + '/customer_id/' + this.context.company_id,
        '_blank' // <- This is what makes it open in a new window.
      );
      // window.location.href = sgl_webservice_videos + 'Download/vid/'+sgl_video_id+'/customer_id/'+this.context.company_id;
    }
    // return sgl_webservice_videos + 'Download?vid='+vid+'&customer_id='+this.context.company_id;
  }

  ////// end download functions ///////////

  componentDidMount() {
    this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/videos/detail/' + this.props.searchParams.get('vid'));
    this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath + '/videos/detail/' + this.props.searchParams.get('vid'));
    this.getAllData();
    if (is_mobile == 1) {
      this.setState({
        is_mobile: is_mobile,
      });
    }

  }

  getVideoData() {
    const self = this;
    axios
      .get(this.sgl_webservice_videos_list + '/' + this.props.searchParams.get('vid') + '/t/' + this.props.searchParams.get('t'), {
        params: {
          customer_id: this.context.company_id,
        },
      })
      .then((res) => {
        // var video_url = this.getVideoUrl(res.data.d_video)
        this.setState({
          is_user_authorized: res.data.is_user_authorized,
          is_show_entry_videos: res.data.is_show_entry_videos,
          video_data: res.data.video,
          videos_list: res.data.d_related_videos,
          total_rows: res.data.total_related_videos,
          play_video_path: res.data.d_video ? res.data.d_video.video_url : "",
          video_to_play: res.data.d_video,
          loading: false,
        });

        var parser = document.createElement('a');
        parser.href = this.state.play_video_path;
        this.context.reportToGA('/sgl-wp-plugin/'+this.context.company_urlpath+'/videos/playback'+parser.pathname);
        this.context.reportToFB('/sgl-wp-plugin/'+this.context.company_urlpath+'/videos/playback'+parser.pathname);
        this.logVideoPlayback();

      });   
  }

  logVideoPlayback(){
    var browser = this.getBrowserInfo();
    axios
      .get(this.sgl_webservice_videos + 'LogVideoPlayback', {
        params: {
          customer_id: this.context.company_id,
          vid: this.state.video_to_play.videos_sgl_id,
          browser_info: browser,
          ip_address: this.context.ip_address,
          isMobile: this.context.is_mobile,
          is_iphone: false,
          state: 'video played',
          from_wp_api: true,
        },
      })
      .then(
        (response) => {

        },
        (error) => { }
      );
  }

  getAllData() {
    this.getUserData();

  }
  getUserData() {
    axios.get(this.user_info_url).then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
            login_people_id: response.data.user.sgl_id
          });
          this.context.checkLoginOnSGL();
          this.getVideoData(this.props.searchParams.get('vid'), response.data.user.sgl_id);
        } else {
          this.getVideoData(this.props.searchParams.get('vid'), -1);
        }
      },
      (error) => { }
    );

  }

  getVideoThumbUrl(video) {
    if (video["videos_thumbnail"] && video["videos_thumbnail"] != "false") {
      // var current_cdn = ((video['videos_other_url'])?video['videos_other_url']:sfConfig::get('app_thumb_url'));
      var video_url =
        video.videos_other_url +
        "/" +
        video.videos_filepath.substring(
          video.videos_filepath.indexOf("/") + 1
        ) +
        "/" +
        video.videos_thumbnail;

      return video_url;
    } else {
      return horse_logo;
    }
    // video.videos_other_url + '/' + video.videos_filepath.substring(video.videos_filepath.indexOf('/') + 1) + '/' + video.videos_thumbnail
  }

  format_placing(placing) {
    if (placing > 0) {
      var i = placing % 10;
      var place = placing.toString().substring(placing.length - 2);
      // var place=(placing,-2);

      if (i == 1 && place != "11") {
        return placing + "st";
      } else if (i == 2 && place != "12") {
        return placing + "nd";
      } else if (i == 3 && place != "13") {
        return placing + "rd";
      }
      return placing + "th";
    } else {
      return "-";
    }
  }
  getVideoScore(video) {
    var video_faults = "";
    if (video.classes_class_type == "Jumpers") {
      var faults_one =
        video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
      var faults_two =
        video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

      if (video.videos_trip_type && video.videos_trip_type.toString().toLowerCase() == 'jo') {
        // $faults = $trip->time_fault_two + $trip->faults_two;
        video_faults = 'Jump Off';
        if (video.entryxclasses_time_two > 0) {
          video_faults += " with " + faults_two + " faults in " + video.entryxclasses_time_two + " secs.";
        } else if (faults_two > 0) {
          video_faults += " with {$faults} faults.";
        }
      } else {
        // $faults = $trip->time_fault_one + $trip->faults_one;
        video_faults += 'Round 1';
        if (video.entryxclasses_time_one > 0) {
          video_faults += " with " + faults_one + " faults in " + video.entryxclasses_time_one + " secs.";
        } else if (faults_one > 0) {
          video_faults += " with " + faults_one + " faults.";
        }
      }
      return video_faults;

    } else if (video.classes_class_type == "Hunters" || video.classes_class_type == "Equitation") {
      // getting sum or avg of non-zero score values
      var score_array = [
        video.entryxclasses_scoreone,
        video.entryxclasses_scoretwo,
        video.entryxclasses_scorethree,
        video.entryxclasses_scorefour,
        video.entryxclasses_scorefive,
        video.entryxclasses_scoresix,
      ];
      var non_zero_nums = score_array.filter(
        (item) => isFinite(item) && item !== 0
      );
      var score = 0;
      if (non_zero_nums.length > 0) {
        score = non_zero_nums.reduce((a, b) => a + b, 0);
        if (this.state.video_data.hunter_scoreby == "Average Score") {
          score = score / non_zero_nums.length;
        }
      }

      if (score > 0) {
        return score;
      }
    } else if (video.classes_class_type == 'Dressage') {
      return (video.dressage_totalscore_percent) ? (video.dressage_totalscore_percent * 100) + '%' : null;
    }

    return;
  }

  getFaults(video) {
    var video_faults = "";
    if (video.classes_class_type == "Jumpers") {
      var faults_one =
        video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
      var faults_two =
        video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

      if (video.entryxclasses_disqualify_status_one) {
        video_faults = "R1: " + video.entryxclasses_disqualify_status_one;
      } else if (video.entryxclasses_time_one > 0) {
        video_faults =
          "R1: " +
          faults_one +
          "/" +
          video.entryxclasses_time_one +
          "s";
      } else {
        video_faults = "R1: N/A";
      }

      if (video.entryxclasses_disqualify_status_two) {
        video_faults += " - JO: " + video.entryxclasses_disqualify_status_two;
      } else if (video.entryxclasses_time_two > 0) {
        video_faults +=
          " - JO:" +
          faults_two +
          "/" +
          video.entryxclasses_time_two +
          "s";
      } else {
        video_faults += "";
      }
    } else if (
      video.classes_class_type == "Hunters" ||
      video.classes_class_type == "Equitation"
    ) {
      // getting sum or avg of non-zero score values
      var score_array = [
        video.entryxclasses_scoreone,
        video.entryxclasses_scoretwo,
        video.entryxclasses_scorethree,
        video.entryxclasses_scorefour,
        video.entryxclasses_scorefive,
        video.entryxclasses_scoresix,
      ];
      var non_zero_nums = score_array.filter(
        (item) => isFinite(item) && item !== 0
      );
      var score = 0;
      if (non_zero_nums.length > 0) {
        score = non_zero_nums.reduce((a, b) => a + b, 0);
        // if(hunter_scoreby == "Average Score"){
        //     score = score/non_zero_nums.length;
        // }
      }

      if (score > 0) {
        video_faults = "Score: " + Number(score.toFixed(3));
      } else {
        video_faults = "Score: N/A";
      }
    }

    return video_faults;
  }

  getVideoPlayerFaults(video) {
    var video_faults = "";
    if (video.classes_class_type == "Jumpers") {
      var faults_one =
        video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
      var faults_two =
        video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

      if (video.videos_trip_type && video.videos_trip_type.toString().toLowerCase() == 'jo') {
        // $faults = $trip->time_fault_two + $trip->faults_two;
        video_faults = ' - Jump Off';
        if (video.entryxclasses_time_two > 0) {
          video_faults += " with " + faults_two + " faults in " + video.entryxclasses_time_two + " secs.";
        } else if (faults_two > 0) {
          video_faults += " with {$faults} faults.";
        }
      } else {
        // $faults = $trip->time_fault_one + $trip->faults_one;
        video_faults += ' - Round 1';
        if (video.entryxclasses_time_one > 0) {
          video_faults += " with " + faults_one + " faults in " + video.entryxclasses_time_one + " secs.";
        } else if (faults_one > 0) {
          video_faults += " with " + faults_one + " faults.";
        }
      }


    } else if (video.classes_class_type == "Hunters") {
      // getting sum or avg of non-zero score values
      var score_array = [
        video.entryxclasses_scoreone,
        video.entryxclasses_scoretwo,
        video.entryxclasses_scorethree,
        video.entryxclasses_scorefour,
        video.entryxclasses_scorefive,
        video.entryxclasses_scoresix,
      ];
      var non_zero_nums = score_array.filter(
        (item) => isFinite(item) && item !== 0
      );
      var score = 0;
      if (non_zero_nums.length > 0) {
        score = non_zero_nums.reduce((a, b) => a + b, 0);
        // if(hunter_scoreby == "Average Score"){
        //     score = score/non_zero_nums.length;
        // }
      }

      if (score > 0) {
        video_faults = " with " + score + " score.";
      }
    }

    return video_faults;
  }
  format_currancy(amount) {
    return (
      "$" + (amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    );
  }
  format_date(unformatted_date) {
    var month = new Array();
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sep";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    var unformatted_date_split = (unformatted_date && unformatted_date.split) ? unformatted_date.split('T')[0] : unformatted_date;
    var formatted_date = new Date(unformatted_date_split);
    formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
    // formatted_date.getUTCMonth;
    return (
      month[formatted_date.getMonth()] +
      " " +
      formatted_date.getDate() +
      "," +
      formatted_date.getFullYear()
    );
  }

  format_time(timeString) {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 || H === 24 ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  }

  ///////// video player functions ///////////
  getCompanyName() {
    if (this.context.company_id == 15) {
      return 'PALM BEACH INTERNATIONAL EQUESTRIAN CENTER'
    } else {
      return 'ShowGroundsLive.com'
    }
  }
  getVideoPlayerMsg() {
    var message = '';
    if (this.state.video_to_play && Object.keys(this.state.video_to_play).length > 0) {
      if (this.context.is_mobile) {
        message = '#' + this.state.video_to_play.entries_number + ' - ' + this.state.video_to_play.entries_horse + ' | ' + this.state.video_to_play.entryxclasses_rider_name
      } else {
        message = '#' + this.state.video_to_play.entries_number + ' - ' + this.state.video_to_play.entries_horse + ' | ' + this.state.video_to_play.entryxclasses_rider_name + ' | ' + this.state.video_to_play.classes_name + this.getVideoPlayerFaults(this.state.video_to_play)

      }
    } else {
      message = "Video not found"
    }
    return message;
  }
  // playVideo(video_path, video_to_play, is_preview){
  //   this.setState({'play_video_path': video_path, video_to_play: video_to_play, playing_preview: is_preview})

  //   this.openPlayVideoModal();
  // }
  playRelatedVideo(video) {
    if (video.subscribed_to_play) {
      let base_path = this.context.basePath ? this.context.basePath : '';

      window.location.href = 'https://' + window.location.hostname + base_path + '/videos/detail?vid=' + video.videos_sgl_id + '&t=' + video.share_code
    } else {
      this.setState({
        video_to_subscribe: video,
        is_open_do_subscription_modal: true,
        is_download_subscription: false,
        // playing_video: true
      })
    }
  }

  ///// get URL functions ///////
  openGetVideoUrlModal() {
    this.setState({
      is_open_get_video_url: true,
    });
    // window.jwplayer("myDetailElement").play(false);
  }
  afterOpenUrlModal() {
    const input = document.getElementById('video_url');
    input.focus();
    input.select();
  }
  copyToClipboard(id) {
    var copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("Copy");
    this.closeGetVideoUrlModal();
    // e.target.innerHTML = "Copied!";
    // setTimeout(function(){ e.target.innerHTML = "Copy"; }, 2000);
    return false;
  }
  closeGetVideoUrlModal() {
    this.setState({
      is_open_get_video_url: false,
    });
    // window.jwplayer("myDetailElement").play();
  }
  ///// end get URL functions ///////

  ///// report problem functions ///////

  callReportProblemAPI(subject, description, video_id) {
    var browser = this.getBrowserInfo();
    axios.get(this.sgl_webservice_videos + 'ReportProblem', {
      params: {
        complaintType: 'Video Problem',
        complaintSubject: subject,
        complaintDescription: description,
        vid: video_id,
        browser: browser,
        ip_address: this.context.ip_address,
        customer_id: this.context.company_id
      }
    }).then(res => {
      document.getElementById('report_problem').style.display = "block";
      document.getElementById('report_problem-wait').style.display = "none";
      if (res.data.result) {
        this.setState({
          video_reported: true
        });
      } else {
        this.setState({
          report_problem_error_msg: res.data.validation_result.error_messages,
        });
        document.getElementById('report_problem_warning').style.display = "block";
      }
    })
  }
  openReportProblemModal() {
    this.setState({
      is_open_report_problem_modal: true,
      video_reported: false
    });
    // window.jwplayer("myDetailElement").play(false);
  }
  reportProblem() {
    document.getElementById('report_problem_warning').style.display = "none";

    let kind_of_problem = document.getElementById("kind_of_problem");
    let description = document.getElementById("prob_description");
    var error = "";
    if (kind_of_problem.value == '-1') {
      error = 'Please select Kind of Problem.';
    } else if (!description.value || description.value == '') {
      error = 'Please provide Description.';
    }
    if (error == "") {
      document.getElementById('report_problem').style.display = "none";
      document.getElementById('report_problem-wait').style.display = "block";

      this.callReportProblemAPI(kind_of_problem.value, description.value, this.state.video_to_play.videos_sgl_id);
      // this.setState({video_reported: true});

    } else {
      this.setState({ report_problem_error_msg: error });
      document.getElementById('report_problem_warning').style.display = "block";
    }

  }
  closeReportProblemModal() {
    this.setState({
      is_open_report_problem_modal: false,
      video_reported: false
    });
    // window.jwplayer("myDetailElement").play();
  }
  ///// end report problem functions ///////
  ///// playlist functions ///////////
  getVideoPlaylists(video_id) {
    axios.get(this.sgl_webservice_videos + 'FetchPlaylists', {
      params: {
        video_id: video_id,
        customer_id: this.context.company_id
      }
    }).then(res => {
      if (res.data.results) {
        this.setState({
          video_playlists: res.data.playlists,
          playlist: res.data.playlists,
          fetching_playlist: false
        });
      } else {
        this.setState({
          video_playlists: [],
          fetching_playlist: false
        });
      }
    })
  }
  callAddToPlaylistAPI(video_id, playlist_id) {
    axios.get(this.sgl_webservice_videos + 'AddToPlaylist', {
      params: {
        playlist_id: playlist_id,
        video_id: video_id,
        customer_id: this.context.company_id
      }
    }).then(res => {
      if (res.data.state == 'error') {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      } else if (res.data.state == 'added') {
        this.setState({ create_playlist_success_msg: "Successfully added to playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.state.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_success_msg: "Successfully removed from playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.state.video_to_play.videos_sgl_id);
      }

    })
  }
  callCreatePlaylistAPI(video_id, playlist_name) {
    axios.get(this.sgl_webservice_videos + 'CreatePlaylist', {
      params: {
        name: playlist_name,
        video_id: video_id,
        customer_id: this.context.company_id
      }
    }).then(res => {
      if (res.data.state == 'success') {
        this.setState({ create_playlist_success_msg: "Successfully added to new playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.state.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      }

    })
  }
  callRemovePlaylistAPI(playlist_id) {
    axios.get(this.sgl_webservice_videos + 'RemoveFromPlaylist', {
      params: {
        playlist_id: playlist_id,
        customer_id: this.context.company_id
      }
    }).then(res => {
      if (res.data.state == 'success') {
        this.setState({ create_playlist_success_msg: "Playlist successfully removed." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.state.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      }

    })
  }
  checkVideoInPlaylist(playlist_id) {
    var playlist = this.state.video_playlists.find(c => (c.sgl_id == playlist_id));
    if (playlist && playlist.VideoxPlaylists.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  openAddToPlaylistModal() {
    this.getVideoPlaylists(this.state.video_to_play.videos_sgl_id);
    this.setState({
      is_open_add_to_playlist_modal: true,
    });
    // window.jwplayer("myDetailElement").play(false);
  }
  addVideoToPlaylist(e, playlist_id) {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";
    this.setState({
      fetching_playlist: true,
    });
    this.callAddToPlaylistAPI(this.state.video_to_play.videos_sgl_id, playlist_id);
  }
  addToPlaylist() {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";

    let playlist_name = document.getElementById("playlist_name");
    if (playlist_name.value && playlist_name.value != '') {
      this.setState({
        fetching_playlist: true,
      });
      this.callCreatePlaylistAPI(this.state.video_to_play.videos_sgl_id, playlist_name.value);
    } else {
      this.setState({ create_playlist_error_msg: "Please enter Playlist name." });
      document.getElementById('create_playlist_warning').style.display = "block";
    }
  }
  removePlaylist(playlist_id) {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";
    this.setState({
      fetching_playlist: true,
    });
    this.callRemovePlaylistAPI(playlist_id)
  }
  closeAddToPlaylistModal() {
    this.setState({
      is_open_add_to_playlist_modal: false,
      fetching_playlist: true,
      video_playlists: []
    });
    // window.jwplayer("myDetailElement").play();
  }
  ///// end playlist functions ///////

  ///// share functions ///////
  shareOnFB(link) {
    if (link != '') {
      var win = window.open("https://www.facebook.com/sharer/sharer.php?u=" + link, '_blank');
      win.focus();
    }
  }

  shareOnTwitter(link) {
    if (link != '') {
      var win = window.open("https://twitter.com/intent/tweet?url=" + link, '_blank');
      win.focus();
    }
  }

  mailto(link) {
    if (link != '') {
      var win = window.open("mailto:?subject= &body=" + link, '_blank');
      win.focus();
    }
  }
  ///// end share functions ///////

  ///////// end video player functions ///////////
  render() {
    let inIframe = false;
    // if(window.location !== window.parent.location){
    //   inIframe = true;
    // }
    const configDefaults = { width: '100%', height: '100%' };
    const loading = this.state.loading;

    if (loading) {
      return null;
    }
    return (
      <div className="sgl-plugin videos-css">
        {/* <h1>Videos</h1> */}
        <div className='video_player_detail'>
          <div className='detail_player_options'>
            <div className='detail_thePlayer_infobox'>

              <div className="top-div-detail">

                {(!this.context.is_mobile) &&
                  <b>{this.getCompanyName()}</b>
                }
                <br />
                <span>{this.getVideoPlayerMsg()}</span>
              </div>

            </div>
            {(this.state.video_to_play && Object.keys(this.state.video_to_play).length > 0) &&

              <div className="flex-container-row">
                {(this.state.is_user_authorized) &&
                  <div className="flex-container-column">
                    <div className="modalVideoOptionButton" onClick={this.openReportProblemModal}><img src={report_icon} alt="Report Icon" /></div>
                    {(!this.state.playing_preview) &&
                      <div className="modalVideoOptionButton" onClick={this.openAddToPlaylistModal}><img src={add_playlist_icon} alt="Add to Playlist Icon" /></div>
                    }
                    {(!this.context.is_mobile && !this.props.playing_preview) && <div className="modalVideoOptionButton display_it"><a onClick={this.fetchFile}><img src={download_video} alt="Download Video Icon" /></a></div>}


                  </div>
                }

              </div>
            }
          </div>
          <div id="myDetailElement">
                <JWPlayer
                    config={configDefaults}
                    file={this.state.play_video_path}
                    image= {this.state.video_to_play.thumb_url}
                    // library={process.env.PUBLIC_URL + '/jwplayer8.js?v=20230124-1'}
                    library={"https://cdn.jwplayer.com/libraries/hMVctbog.js"}
                />
                        
          </div>
        </div>
        <div className="flex-video-container video-data sgl-add_entry">
          <div className="video_data_container ">
            <table className="table video-data-table">

              <tbody>
                {this.state.video_to_play.entries_number &&
                  <tr>
                    <th colspan="1" className="details-table-head">Entry:</th>
                    <td colspan="2">{this.state.video_to_play.entries_number} - {this.state.video_to_play.entries_horse}</td>
                  </tr>
                }
                {this.state.video_to_play.entryxclasses_rider_name &&
                  <tr>
                    <th colspan="1" className="details-table-head">Rider:</th>
                    <td colspan="2">{this.state.video_to_play.entryxclasses_rider_name}</td>
                  </tr>
                }
                {this.state.video_to_play.entries_trainer &&
                  <tr>
                    <th colspan="1" className="details-table-head">Trainer</th>
                    <td colspan="2">{this.state.video_to_play.entries_trainer}</td>
                  </tr>
                }
                {this.state.video_to_play.entries_owner &&
                  <tr>
                    <th colspan="1" className="details-table-head">Owner:</th>
                    <td colspan="2">{this.state.video_to_play.entries_owner}</td>
                  </tr>
                }
                {(this.state.is_show_entry_videos && this.getVideoScore(this.state.video_to_play)) &&
                  <tr>
                    <th colspan="1" className="details-table-head">Score:</th>
                    <td colspan="2">{this.getVideoScore(this.state.video_to_play)}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="video_data_container ">
            <table className="table video-data-table">

              <tbody>
                {this.state.video_data.show_day &&
                  <tr>
                    <th colspan="1" className="details-table-head">Date:</th>
                    <td colspan="2">{this.format_date(this.state.video_data.show_day)}</td>
                  </tr>
                }
                {this.state.video_to_play.classes_number &&
                  <tr>
                    <th colspan="1" className="details-table-head">Class:</th>
                    <td colspan="2">{this.state.video_to_play.classes_number} - {this.state.video_to_play.classes_name}</td>
                  </tr>
                }
                {this.state.video_data.division_name &&
                  <tr>
                    <th colspan="1" className="details-table-head">Division</th>
                    <td colspan="2">{this.state.video_data.division_name}</td>
                  </tr>
                }
                {this.state.video_data.ringname &&
                  <tr>
                    <th colspan="1" className="details-table-head">Ring:</th>
                    <td colspan="2">{this.state.video_data.ringname}</td>
                  </tr>
                }
                {this.state.video_to_play.show_tables_show_name &&
                  <tr>
                    <th colspan="1" className="details-table-head">Show:</th>
                    <td colspan="2">{this.state.video_to_play.show_tables_show_name}</td>
                  </tr>
                }

              </tbody>
            </table>
          </div>
        </div>


        <div
          id="videos_listing"
          className="grid"
        >
          <div className="related-videos-header header-bg" >
            RELATED VIDEOS
          </div>
          <div className="flex-video-container">

            {this.state.total_rows > 0 ? (
              this.state.videos_list.map((video, index) => {
                return (
                  <div className="video_container ">
                    <div className="video-content">

                      <div className="thumb-image">
                        {/* <img src={this.getVideoThumbUrl(video)} /> */}
                        <img src={video.thumb_url} />
                        {video.subscribed_to_play ? (
                          <span className="play-video-strip green">
                            <img src={play_video} /> Play Video
                          </span>
                        ) : (
                          <span className="play-video-strip orange">
                            <img src={play_video} /> Subscribe
                          </span>
                        )}
                        <a onClick={() => this.playRelatedVideo(video)} className="play-wrapper">

                          {/* <a onClick={
                          event =>  window.location.href=site_url+'/videos/detail?vid='+video.videos_sgl_id + '&t=' + video.share_code
                          } className="play-wrapper"> */}
                          <span className="play-button">
                            <span className="play">
                              <img src={play} />
                            </span>
                          </span>
                        </a>

                      </div>
                      <div className="video_details">
                        <div>
                          <a onClick={() => this.playRelatedVideo(video)} className="cursor-pointer">
                            <strong className="link_color">
                              {video.entries_number +
                                " - " +
                                video.entries_horse}
                            </strong>
                            {video.entryxclasses_placing > 0 && (
                              <span
                                className={
                                  "place_" +
                                  video.entryxclasses_placing +
                                  " placing"
                                }
                              >
                                {this.format_placing(
                                  video.entryxclasses_placing
                                )}
                              </span>
                            )}
                            <br />
                            <span className="sgl-add_entry">
                              {video.entryxclasses_rider_name}
                            </span>
                            <br />
                            <span className="sgl-add_entry">
                              {video.classes_number +
                                " - " +
                                video.classes_name +
                                " (" +
                                video.videos_trip_type.toUpperCase() +
                                ")"}{" "}
                            </span>
                            <br />
                            <span className="sgl-add_entry">
                              {video.show_tables_show_name}
                            </span>
                            <br />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="video_container ">
                <div className="video-content">
                  <div className="thumb-image">
                    <img src={horse_logo} />
                    <span className="float-left">No videos Found</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <AddModal
          isOpen={this.state.is_open_get_video_url}
          onAfterOpen={this.afterOpenUrlModal}
          onRequestClose={this.closeGetVideoUrlModal}
          className="mymodal modal-width-small"
          overlayClassName="myoverlay"
          ariaHideApp={false}
        >

          <h2>Get Video Url</h2>
          <p>Copy to clipboard: Ctrl+C, Enter</p>
          <form>
            <input type="text" id="video_url" value={this.state.play_video_path} />
            <div className="align-buttons">
              <button className='left' onClick={this.closeGetVideoUrlModal}>
                Close
              </button>
              <button id='copy' className='right' onClick={() => this.copyToClipboard('video_url')}>
                Copy
              </button>
            </div>
          </form>
        </AddModal>
        <AddModal
          isOpen={this.state.is_open_report_problem_modal}
          // onAfterOpen={this.afterOpenUrlModal}
          onRequestClose={this.closeReportProblemModal}
          className="mymodal modal-width-small"
          overlayClassName="myoverlay"
          ariaHideApp={false}
        >

          <h2>Report a Problem</h2>
          {this.state.video_reported ?
            <span id="problem_reported_success" className=''>Thank You!<br />Your request about the problem you are facing has been recieved. We shall contact you soon.</span>
            :
            <div>
              <div className="add_modal_div" id='kind_div'>
                <h4>Kind of problem</h4>
                <div style={{ clear: "both" }}></div>
                <div className="add_modal_div txt-field-container-modal">
                  <select className="" id='kind_of_problem'>
                    <option value="-1">Please Select...</option>
                    <option value='Incorrect horse/rider/class identification'>Incorrect horse/rider/class identification</option>
                    <option value="Poor Quality">Poor Quality</option>
                    <option value="Other">Other</option>

                  </select>
                </div>

              </div>
              <div className="add_modal_div" id='desc_div'>
                <h4>Description</h4>
                <div style={{ clear: "both" }}></div>
                <div className="add_modal_div txt-field-container-modal">
                  <textarea placeholder='' id="prob_description" rows="10" />
                </div>

              </div>
            </div>
          }
          <div id='report_problem_warning' style={{ textIndent: "2px" }} className='required display_none'>{this.state.report_problem_error_msg}</div>

          {!this.state.video_reported ?
            <div className="align-buttons">
              <button className='left' onClick={this.closeReportProblemModal}>
                Close
              </button>
              <span id="report_problem-wait" className='right display_none'>  <img src={indicator_icon} /></span>
              <button id='report_problem' className='right' onClick={() => this.reportProblem()}>
                Submit
              </button>
            </div>
            :
            <div className="">
              <button className='close-right' onClick={this.closeReportProblemModal}>
                Close
              </button>
            </div>
          }
        </AddModal>
        <AddModal
          isOpen={this.state.is_open_add_to_playlist_modal}
          // onAfterOpen={this.afterOpenUrlModal}
          onRequestClose={this.closeAddToPlaylistModal}
          className="mymodal modal-width-small"
          overlayClassName="myoverlay"
          ariaHideApp={false}
        >

          <h2>Add to Playlist</h2>
          {this.state.fetching_playlist ?
            <span id="fetch-playlist-wait" className=''>  <img src={indicator_icon} /></span>
            :
            <div className="add_modal_div" id='add_people_name_div'>

              {(this.state.video_playlists.length > 0) ?
                this.state.video_playlists.map((play_list, index) => {
                  return (
                    <li className='class_list_li'>
                      <input className="checkbox-class" type="checkbox" name="playlist" id={"play_list_" + play_list.sgl_id} checked={this.checkVideoInPlaylist(play_list.sgl_id)} onChange={e => this.addVideoToPlaylist(e, play_list.sgl_id)} />
                      <label for={"play_list_" + play_list.sgl_id}>  {play_list.name}</label>
                      <img src={delete_image} className="placing-icon trash-icon" onClick={() => this.removePlaylist(play_list.sgl_id)} />

                    </li>

                  )
                })
                :
                <span>You haven't created any playlist yet.</span>
              }

            </div>
          }
          <br />
          <br />
          <h2>Create Playlist</h2>

          <input type="text" placeholder='Playlist name' id="playlist_name" />
          <div id='create_playlist_warning' style={{ textIndent: "2px" }} className='required display_none'>{this.state.create_playlist_error_msg}</div>
          <div id='create_playlist_success' style={{ textIndent: "2px" }} className='success_msg display_none'>{this.state.create_playlist_success_msg}</div>
          <div className="align-buttons">
            <button className='left' onClick={this.closeAddToPlaylistModal}>
              Close
            </button>
            <button id='copy' className='right' onClick={() => this.addToPlaylist()}>
              Add
            </button>
          </div>
        </AddModal>
        {(this.state.is_open_do_subscription_modal) &&
          <AddModal
            isOpen={this.state.is_open_do_subscription_modal}
            // onAfterOpen={this.afterOpenUrlModal}
            onRequestClose={this.closeDoSubscriptionModal}
            className={"mymodal subscription-modal" + (inIframe ? ' subscription-in-iframe' : '')}
            overlayClassName="myoverlay"
            ariaHideApp={false}
          >
            <VideoSubscription
              is_download_subscription={this.state.is_download_subscription}
              is_video_subscription={true}
              subscription_type={'video'}
              video_to_play={this.state.video_to_subscribe}
              closeSubscriptionModal={this.closeDoSubscriptionModal}
              playVideoAfterSubscribe={this.downloadVideoAfterSubscribe}
              ref={this.VideoSubscriptionElement}
            />
          </AddModal>
        }

      </div>
    );
  }
}
VideoDetail.contextType = SglContext;
export default function (props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams()

  return <VideoDetail {...props} navigate={navigate} searchParams={searchParams} />;
}